import React from 'react'
import cn from 'classnames'
import Paper from '@material-ui/core/Paper'
import MUBreadcrumbs from '@material-ui/core/Breadcrumbs'
import Link from '@material-ui/core/Link'
import IconButton from '@material-ui/core/IconButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { injectIntl } from 'react-intl'
import messages from '../translate'

function Breadcrumbs(props) {
  const { breadcrumbs, backClick } = props
  const showTitle = Boolean(!breadcrumbs.form.title)
  const {
    intl: { formatMessage },
  } = props

  return (
    <Paper className="lbf-breadcrumb-paper">
      {showTitle && (
        <div className="lbf-bc-title">
          {formatMessage(messages.logbookBreadcrumbsTitle)}
        </div>
      )}
      {!showTitle && (
        <IconButton aria-label="back" size="small" onClick={backClick}>
          <ArrowBackIcon />
        </IconButton>
      )}
      {!showTitle && (
        <MUBreadcrumbs aria-label="breadcrumb" className="lbf-breadcrumb">
          {Object.keys(breadcrumbs).map((key, index) => {
            const { title, onClick } = breadcrumbs[key]

            if (!title) {
              return null
            }

            return (
              <Link
                color="inherit"
                onClick={onClick}
                key={index}
                className={cn({
                  clickable: Boolean(onClick),
                })}>
                {title}
              </Link>
            )
          })}
        </MUBreadcrumbs>
      )}
    </Paper>
  )
}

export default injectIntl(Breadcrumbs)
